import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '@keyframes dashboardLivePulse': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0.5
      },
      '100%': {
        opacity: 1
      }
    }
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  icon: {
    fontSize: 12,
    color: (props) => props.live ? '#4caf50' : '#9e9e9e',
    animation: (props) => props.live ? 'dashboardLivePulse 2s ease-in-out infinite' : 'none'
  },
  text: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: (props) => props.live ? '#4caf50' : '#9e9e9e',
    textTransform: 'uppercase',
    letterSpacing: 0.5
  }
}));

const LiveIndicator = ({ live = false, text = 'Live', showText = true }) => {
  const classes = useStyles({ live });
  
  return (
    <Box className={classes.container}>
      <FiberManualRecordIcon className={classes.icon} />
      {showText && (
        <Typography className={classes.text}>
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default LiveIndicator;
